export function getOrCreateTabId() {
  try {
    let tabId = sessionStorage.getItem("ffw_tab_id");
    if (!tabId) {
      tabId = generateSimpleId();
      sessionStorage.setItem("ffw_tab_id", tabId);
    }
    return tabId;
  } catch (e) {
    return generateSimpleId();
  }
}

function generateSimpleId() {
  const random = Math.random().toString(36).slice(2);
  const time = Date.now().toString(36);
  return `${time}-${random}`;
}

export function notifyDownloadActivity(isActive, payload = {}) {
  try {
    const message = { type: "ffw-download-activity", isActive: !!isActive, ...payload };
    if (typeof BroadcastChannel !== "undefined") {
      const bc = new BroadcastChannel("ffweddingz-download");
      bc.postMessage(message);
      bc.close();
    } else if (typeof localStorage !== "undefined") {
      localStorage.setItem("ffw_download_activity", JSON.stringify({ ...message, ts: Date.now() }));
      localStorage.removeItem("ffw_download_activity");
    }
  } catch (_) {}
}


